<div>
  <form-field class="front control" [label]="label">
    <input type="password" [formControl]="input" [placeholder]="placeholder" showPassword>
  </form-field>
  <p class="text-bold mb-1" i18n="@@password.complexity.details">Password must include:</p>
  <ul class="d-flex justify-content-between list">
    <li class="option" [class.error]="hasNumLettersError">
      <i [ngClass]="hasNumLettersError ? 'icon-ellipse': 'icon-check-round'"></i>
      <span class="p-1"></span>
      <p i18n="@@password.complexity.numbersLetters" class="text-sm mb-0" [class.error]="hasNumLettersError">Numbers and letters</p>
    </li>
  
    <li class="option" [class.error]="hasLengthError">
      <i [ngClass]="hasLengthError ? 'icon-ellipse': 'icon-check-round'"></i>
      <span class="p-1"></span>
      <p i18n="@@password.complexity.min" class="text-sm mb-0">Min 8 characters</p>
    </li>

    <li class="option" [class.error]="hasUpperLowerCaseError">
      <i [ngClass]="hasUpperLowerCaseError ? 'icon-ellipse': 'icon-check-round'"></i>
      <span class="p-1"></span>
      <p i18n="@@password.complexity.upperLowerCases" class="text-sm mb-0" [class.error]="hasUpperLowerCaseError">Upper and lower case</p>
    </li>
  </ul>
</div>
